
import { countryList } from './country'
import { loggedInUser } from './auth'
import { get } from 'lodash'

export const getUserStoredCountry = () => {
    const country_id = get(loggedInUser(), "country")
    return countryList.getCountryForId(country_id)
}